<template>
  <div class="card">
    <div class="card-header bg-dark">
      <h3 class="mb-0 text-white">
        รายการโค๊ดโปรโมชั่น
        <small class="ml-1">({{ data.length | format(0) }} รายการ)</small>
      </h3>
    </div>

    <el-table
      row-key="id"
      header-row-class-name="thead-light"
      :data="queriedData"
    >
      <el-table-column label="โค๊ดโปรโมชั่น" min-width="100px">
        <div slot-scope="{ row }">
          {{ row.Code }}
        </div>
      </el-table-column>
      <el-table-column label="เครดิต" min-width="75px">
        <div slot-scope="{ row }">
          {{ row.Amount }}
        </div>
      </el-table-column>
      <el-table-column label="จำนวนโค๊ด" min-width="75px">
        <div slot-scope="{ row }">
          {{ row.Limit }}
        </div>
      </el-table-column>
      <el-table-column label="ใช้ไปแล้ว" min-width="75px">
        <div slot-scope="{ row }">
          {{ row.Used }}
        </div>
      </el-table-column>
      <el-table-column label="แก้ไขข้อมูล" align="center" min-width="75px">
        <div slot-scope="{ row }">
          <base-button type="dark" size="sm" @click="editRedeem(row)">
            <i class="fas fa-wrench" />
          </base-button>
        </div>
      </el-table-column>
      <el-table-column label="ลบข้อมูล" align="center" min-width="75px">
        <div slot-scope="{ row }">
          <base-button type="danger" size="sm" @click="deleteRedeem(row)">
            <i class="fas fa-ban" />
          </base-button>
        </div>
      </el-table-column>
    </el-table>
    <div class="card-footer d-flex justify-content-between">
      <p class="card-category">
        Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
      </p>

      <base-pagination
        class="pagination-no-border"
        :per-page="pagination.perPage"
        :total="total"
        v-model="pagination.currentPage"
      />
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "../../components";

import moment from "moment";
import RedeemService from "../../services/redeem.service";
import tablePagination from "../../mixins/tablePagination";

export default {
  props: ["data"],
  mixins: [tablePagination([], 10)],
  components: {
    BasePagination,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  methods: {
    editRedeem(redeem) {
      this.$emit("editRedeem", redeem);
    },
    deleteRedeem(redeem) {
      this.$emit("deleteRedeem", redeem);
    },
  },
  created() {
    this.updateTableData(this.data);
  },
  watch: {
    data(v) {
      this.updateTableData(v);
    },
  },
};
</script>
